/** All money is integer cents. Floats exist only at the formatting boundary. */

export const toCents = (dollars: number): number => Math.round(dollars * 100);

export const fmtCents = (cents: number): string => {
  const sign = cents < 0 ? '-' : '';
  const abs = Math.abs(cents);
  const dollars = Math.floor(abs / 100);
  const rem = String(abs % 100).padStart(2, '0');
  return `${sign}$${dollars.toLocaleString('en-US')}.${rem}`;
};

/** round a fractional cent amount to a whole cent — the single rounding rule (§3.5) */
export const roundCents = (v: number): number => Math.round(v);

export const fmtQty = (qty: number, unit: string): string => {
  if (unit === 'sq ft' || unit === 'lin ft') return Math.round(qty).toLocaleString('en-US');
  return (Math.round(qty * 100) / 100).toLocaleString('en-US');
};
